import shared from "@/seo/shared";
import { useSeo } from "@/seo/useSeo";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { SubHero } from "@/components/site/SubHero";
import { Contact } from "@/components/site/Contact";
import { ServiceGrid, LocationLinks } from "@/pages/LocationPage";

const AREA = shared.EXTRA.find((p) => p.path === "/einsatzgebiet");
const CONTACT = shared.EXTRA.find((p) => p.path === "/kontakt");

export function AreaPage({ consent, onCookies }) {
  useSeo({ ...AREA, ld: [shared.businessLd(), shared.breadcrumbLd([{ name: "Startseite", path: "/" }, { name: "Einsatzgebiet", path: "/einsatzgebiet" }])] });
  return (
    <>
      <Nav />
      <main data-testid="area-page">
        <SubHero h1={AREA.h1} img="roofers-slate" alt="Dachdecker von Christian Bedachungen bei der Arbeit in der Vorderpfalz"
          lead="Von unserem Betrieb in Schifferstadt aus arbeiten wir im Umkreis von rund 25 Kilometern – in der Vorderpfalz und auf der badischen Rheinseite. Kurze Wege bedeuten schnelle Termine und einen Notdienst, der wirklich schnell da ist."
          crumbs={[{ name: "Startseite", path: "/" }, { name: "Einsatzgebiet", path: "/einsatzgebiet" }]} />
        <section className="bg-paper py-20 text-ink sm:py-28">
          <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
            <h2 className="font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Orte, in denen wir für Sie da sind</h2>
            <p className="mt-5 max-w-3xl text-base leading-relaxed text-slate-700 sm:text-lg">Schifferstadt und Speyer sind unser Kerngebiet. Regelmäßig arbeiten wir außerdem in {shared.AREAS.slice(2).join(", ")}. Ihr Ort ist nicht dabei? Rufen Sie uns an – oft finden wir trotzdem einen Termin.</p>
            <div className="mt-8"><LocationLinks /></div>
            <h2 className="mt-20 font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Unsere Leistungen</h2>
            <div className="mt-8"><ServiceGrid /></div>
          </div>
        </section>
        <Contact consent={consent} />
      </main>
      <Footer onCookies={onCookies} />
    </>
  );
}

export function ContactPage({ consent, onCookies }) {
  useSeo({ ...CONTACT, ld: [shared.businessLd(), shared.breadcrumbLd([{ name: "Startseite", path: "/" }, { name: "Kontakt", path: "/kontakt" }])] });
  return (
    <>
      <Nav />
      <main className="pt-20" data-testid="contact-page">
        <h1 className="sr-only">{CONTACT.h1}</h1>
        <Contact consent={consent} />
      </main>
      <Footer onCookies={onCookies} />
    </>
  );
}
